export function isReviewed(upload) {
  if (!upload) { return }
  return upload.approved !== null || !upload.is_portal
}
